module.exports = __webpack_public_path__ + "fonts/perfect-serve.eot";


//////////////////
// WEBPACK FOOTER
// ./~/@ps/common-core/dist/fonts/perfect-serve.eot
// module id = ./node_modules/@ps/common-core/dist/fonts/perfect-serve.eot
// module chunks = 1